import React, { useMemo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getDocumentTypes } from 'Reducers/Document/actions'

import { filterDocumentTypesInThisCountrySelector } from './utils'
import DocumentHistoryTable from '../../../../../../Components/DocumentHistoryTable'
import {
  STATUS_DOCUMENT_APPROVED,
  STATUS_DOCUMENT_MANUALY_APPLOADED,
  STATUS_DOCUMENT_PENDING,
  STATUS_DOCUMENT_REJECTED,
} from '../../../../../../shared/constants'
import { uploadAmbassadorDocument } from '../../../../../../Reducers/Ambassador/actions'
import { createUserDocument } from '../../gql'

const AmbassadorUploadDocumentsWrapper = ({
  ambassador,
  onDocumentUpdate,
  countryCode,
  getAmbassador,
}) => {
  const [documentsData, setDocumentsData] = useState(null)
  const dispatch = useDispatch()

  const ambassadorId = ambassador.id

  const ambassadorDocuments = ambassador.documents.nodes

  useEffect(() => {
    dispatch(getDocumentTypes())
  }, [])

  const selectFilterDocumentTypesInThisCountry = useMemo(
    filterDocumentTypesInThisCountrySelector,
    [],
  )

  const documentTypesList = useSelector(state =>
    selectFilterDocumentTypesInThisCountry(state, countryCode),
  )
  const getOutcome = doc => {
    if (doc.status === STATUS_DOCUMENT_APPROVED) {
      return doc.actor ? `Accepted by ${doc.actor}` : 'Approved'
    }
    if (doc.status === STATUS_DOCUMENT_REJECTED) {
      return doc.actor ? `Rejected by ${doc.actor}` : 'Rejected'
    }
    if (doc.status === STATUS_DOCUMENT_MANUALY_APPLOADED) {
      return 'Manual upload'
    }
    if (doc.status === STATUS_DOCUMENT_PENDING) {
      return 'Pending'
    }
  }
  const getFormatedDocuments = () => {
    if (documentTypesList.length == 0) return
    const formattedAmbassadorDocument = ambassadorDocuments.map(doc => ({
      ...doc,
      outcome: getOutcome(doc),
      uploader: doc.uploader ? doc.uploader : ambassador.email,
      actor: doc.actor ? doc.actor : doc.uploader || ambassador.email,
    }))
    const activeCountryDocumentIds = documentTypesList
      .filter(doc => doc.active)
      .map(doc => Number(doc.id))
    const groupedByTypeId = formattedAmbassadorDocument.reduce(
      (acc, document) => {
        if (activeCountryDocumentIds.includes(document.documentTypeId)) {
          if (acc[document.documentTypeId]) {
            acc[document.documentTypeId].push(document)
          } else {
            acc[document.documentTypeId] = [document]
          }
        } else {
          if (acc.other) {
            acc.other.push(document)
          } else {
            acc.other = [document]
          }
        }
        return acc
      },
      {},
    )

    const formattedGroupedDocuments = activeCountryDocumentIds.map(id => {
      if (groupedByTypeId[id]) {
        return { [id]: groupedByTypeId[id] }
      } else {
        return { [id]: [] }
      }
    })

    if (groupedByTypeId.other) {
      formattedGroupedDocuments.push({ other: groupedByTypeId.other })
    } else {
      formattedGroupedDocuments.push({ other: [] })
    }
    setDocumentsData(formattedGroupedDocuments)
  }

  useEffect(() => {
    if (documentTypesList) {
      getFormatedDocuments()
    }
  }, [documentTypesList])

  const handleUploadDocument = async ({ file, typeId, onCallback }) => {
    const callbacks = {
      onSuccess: async fileURL => {
        await onSaveDocument({ typeId, fileURL, onCallback })
      },
    }
    dispatch(uploadAmbassadorDocument(ambassadorId, file[0], callbacks))
  }

  const onSaveDocument = async ({ typeId, fileURL, onCallback }) => {
    const input = {
      userId: Number(ambassadorId),
      documentTypeId: typeId,
      url: fileURL,
    }
    await createUserDocument({ input })
    onCallback()
    return await getAmbassador()
  }

  const docTypeForOthersDocument = documentTypesList.find(
    doc => doc.name == 'Other',
  )

  return (
    <div>
      {documentsData
        ? documentsData.map(data => {
            const [typeId, documents] = Object.entries(data)[0]
            const documentType = documentTypesList.find(doc => doc.id == typeId)

            return (
              <DocumentHistoryTable
                typeId={typeId}
                documentType={documentType}
                otherDocumentType={docTypeForOthersDocument}
                documentsData={documents}
                updateUserDocument={onDocumentUpdate}
                handleUploadDocument={handleUploadDocument}
              />
            )
          })
        : null}
    </div>
  )
}

export default AmbassadorUploadDocumentsWrapper
